import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useDispatch, useSelector } from "react-redux";
import React, { useEffect, useRef, useState } from "react";
import Select from "react-select";
import qmsWorkflowActions from "../../../_actions/_qmsActions/qmsWorkflowActions";
import { QMS } from "../../../_constants/actionConstants";
import cmtIssueActions from "../../../_actions/_qmsActions/cmtIssueActions";
import { ReactFlowProvider, ReactFlow, MiniMap, Controls, Background } from "reactflow";

export default function CmtModal_ViewWorkflow(props) {
  const { workflowId, showModal, toggleModal } = props;

  const fetching = useSelector((state) => state.qms.fetching);
  const dispatch = useDispatch();
  const reactFlowWrapper = useRef(null);

  useEffect(() => dispatch(qmsWorkflowActions.get(workflowId)), []);
  const workflow = useSelector((state) => state.qms.openWorkflows[workflowId] || null);

  const handleClick_close = (e) => {
    e.preventDefault();
    dispatch({ type: QMS.WORKFLOW.CLEAR, workflowId });
    toggleModal();
  };

  const closeBtn = (
    <button className="close" onClick={handleClick_close}>
      <FontAwesomeIcon icon="times" className="fa-fw text-white" />
    </button>
  );

  return (
    <Modal isOpen={showModal} toggle={handleClick_close} fade={false} size={"xl"}>
      <ModalHeader
        toggle={handleClick_close}
        className="bg-info text-white"
        close={closeBtn}
      >
        <FontAwesomeIcon icon="plus" className="fa-fw mr-2" />
        Viewing Workflow: {workflow ? workflow.name : fetching ? "(Loading...)" : "(N/A)"}
      </ModalHeader>
      <ModalBody>
        <ReactFlowProvider>
          <div
            className="card-body p-2 wrapper"
            ref={reactFlowWrapper}
            style={{ height: "500px", width: "100%" }}
          >
            <ReactFlow
              nodes={(workflow && workflow.nodes) || []}
              edges={(workflow && workflow.edges) || []}
              elementsSelectable={false}
              nodesConnectable={false}
              nodesDraggable={false}
              zoomOnScroll={true}
              zoomOnDoubleClick={true}
              panOnDrag={true}
              fitView
              fitViewOptions={{
                padding: 2,
              }}
            >
              <MiniMap />
              <Controls showInteractive={false} />
              <Background />
            </ReactFlow>
          </div>
        </ReactFlowProvider>
      </ModalBody>
      <ModalFooter className="bg-lightgray">
        <div className="form-group form-row float-right mb-0">
          <button
            type="button"
            name="close"
            id="close"
            className="btn btn-secondary mr-2"
            onClick={handleClick_close}
          >
            Close
          </button>
        </div>
      </ModalFooter>
    </Modal>
  );
}
